<app-search></app-search>
<div class="adaptive-grow-1">
  <div class="fluent-container">
    <br />
    <div class="title-color">
      <h1 class="title">Lista de cargos</h1>
    </div>
    <br />
    <div class="card-header">
      <button id="" class="primary-button" appPermision="/employee+c" (click)="createEmployee()">
        <span class="button-content"> <mat-icon>add_circle</mat-icon> Agregar nuevo </span>
      </button>
    </div>
    <br />
    <div class="table-scroll-wrapper">
      <section class="table-container mat-elevation-z1" tabindex="0">
        <div class="table-adjustable">
          <table
            mat-table
            [dataSource]="
              (asyncEmployees | async) ?? []
                | paginate
                  : {
                      id: 'server',
                      itemsPerPage: limit,
                      currentPage: page,
                      totalItems: total,
                    }
            "
          >
            <ng-container matColumnDef="acciones">
              <th mat-header-cell *matHeaderCellDef>Acciones</th>
              <td mat-cell *matCellDef="let employee">
                <div class="action-buttons">
                  <a
                    title="Editar"
                    class="icon-button"
                    appPermision="/employee+u"
                    (click)="updateEmployee(employee)"
                  >
                    <span class="material-symbols-outlined"><mat-icon>edit</mat-icon></span>
                  </a>
                  <a appOnlysuperuser="/employee" (click)="eliminate(employee)" class="icon-button">
                    <span class="material-symbols-outlined"><mat-icon>delete</mat-icon></span>
                  </a>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef>ID</th>
              <td mat-cell *matCellDef="let employee">
                {{ employee.id }}
              </td>
            </ng-container>

            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>Nombre</th>
              <td mat-cell *matCellDef="let employee">
                {{ employee.name }}
              </td>
            </ng-container>

            <ng-container matColumnDef="relationshipType">
              <th mat-header-cell *matHeaderCellDef>Tipo de relación</th>
              <td mat-cell *matCellDef="let employee">
                {{ employee.relationshipType }}
              </td>
            </ng-container>

            <ng-container matColumnDef="description">
              <th mat-header-cell *matHeaderCellDef>Descripción</th>
              <td mat-cell *matCellDef="let employee">
                {{ employee.description }}
              </td>
            </ng-container>

            <ng-container matColumnDef="communityExperience">
              <th mat-header-cell *matHeaderCellDef>Experiencia comunitaria</th>
              <td mat-cell *matCellDef="let employee">
                {{ employee.communityExperience }}
              </td>
            </ng-container>

            <ng-container matColumnDef="academicExperience">
              <th mat-header-cell *matHeaderCellDef>Experiencia académica</th>
              <td mat-cell *matCellDef="let employee">
                {{ employee.academicExperience }}
              </td>
            </ng-container>

            <ng-container matColumnDef="functions">
              <th mat-header-cell *matHeaderCellDef>Funciones</th>
              <td mat-cell *matCellDef="let employee">
                {{ employee.functions }}
              </td>
            </ng-container>

            <ng-container matColumnDef="experienceTime">
              <th mat-header-cell *matHeaderCellDef>Tiempo de experiencia</th>
              <td mat-cell *matCellDef="let employee">
                {{ employee.experienceTime }}
              </td>
            </ng-container>

            <ng-container matColumnDef="hasMultipleComponents">
              <th mat-header-cell *matHeaderCellDef>Componentes múltiples</th>
              <td mat-cell *matCellDef="let employee">
                {{ employee.hasMultipleComponents ? 'Sí' : 'No' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="hasMultipleLevels">
              <th mat-header-cell *matHeaderCellDef>Niveles múltiples</th>
              <td mat-cell *matCellDef="let employee">
                {{ employee.hasMultipleLevels ? 'Sí' : 'No' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="accompanimenTime">
              <th mat-header-cell *matHeaderCellDef>Tiempo de acompañamiento</th>
              <td mat-cell *matCellDef="let employee">
                {{ employee.accompanimenTime }}
              </td>
            </ng-container>

            <ng-container matColumnDef="compensacionType">
              <th mat-header-cell *matHeaderCellDef>Tipo de compensación</th>
              <td mat-cell *matCellDef="let employee">
                {{ employee.compensacionType }}
              </td>
            </ng-container>

            <ng-container matColumnDef="monthSalary">
              <th mat-header-cell *matHeaderCellDef>Salario mensual</th>
              <td mat-cell *matCellDef="let employee">
                {{ employee.monthSalary }}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="showColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: showColumns" class="highlight-row"></tr>
          </table>
        </div>
      </section>
    </div>
    <pagination-controls
      (pageChange)="fetchEmployee($event)"
      previousLabel="Anterior"
      nextLabel="Siguiente"
      id="server"
    ></pagination-controls>
  </div>
</div>
